export class HtmlHelper
{
    // Element -> tag string
    public static convertElementToTag(element) : string
    {
        return new XMLSerializer().serializeToString(element);
    }

    // <defs>...</defs>
    public static createCustomFontCssTag() : string
    {
        return "";
    }
}